import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Button, Grid, Modal } from 'semantic-ui-react';

import RoleGate from 'components/RoleGate';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';

import {
    makeSelectQueryStringBooleanValue,
    makeSelectQueryStringNumberValue
} from 'workspaces/react-router-selectors';

import { updateQueryString } from 'services/router/actions';
import {
    SpraySubmissionProductId,
    SpraySubmissionProductPayload
} from 'services/spraySubmission/types';
import { AppState } from 'services/types';

import { makeSelectSpraySubmissionPayload } from './selectors';
import { SPRAY_SUBMISSION_VIEW_PAYLOAD_MODAL } from '../../constants';

interface ConnectedProps {
    [SPRAY_SUBMISSION_VIEW_PAYLOAD_MODAL]: boolean;
    spraySubmissionId: SpraySubmissionProductId;
    spraySubmissionPayload: SpraySubmissionProductPayload | null;
}

interface DispatchProps {
    updateQueryString: typeof updateQueryString;
}

type Props = ConnectedProps & DispatchProps;

export class SpraySubmissionViewPayloadModalComponent extends React.PureComponent<Props> {
    get open() {
        const { spraySubmissionViewPayloadModal, spraySubmissionId } =
            this.props;

        return !!spraySubmissionViewPayloadModal && !!spraySubmissionId;
    }

    handleClose = (): void => {
        const { ...props } = this.props;

        props.updateQueryString({
            [SPRAY_SUBMISSION_VIEW_PAYLOAD_MODAL]: undefined,
            spraySubmissionId: undefined
        });
    };

    render(): React.ReactElement {
        const { spraySubmissionPayload } = this.props;

        return (
            <RoleGate requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}>
                <Modal
                    open={this.open}
                    onClose={this.handleClose}
                    size="tiny"
                    centered={false}
                    closeIcon
                >
                    <Modal.Header>View Payload</Modal.Header>
                    <Modal.Content>
                        <Grid>
                            <Grid.Column width={16}>
                                <textarea
                                    disabled
                                    style={{
                                        width: '100%',
                                        minHeight: '250px'
                                    }}
                                    value={JSON.stringify(
                                        spraySubmissionPayload,
                                        null,
                                        2
                                    )}
                                />
                            </Grid.Column>
                            <Grid.Column width={16}>
                                <Button
                                    type="button"
                                    color="grey"
                                    onClick={this.handleClose}
                                    fluid
                                    basic
                                    primary
                                >
                                    Close
                                </Button>
                            </Grid.Column>
                        </Grid>
                    </Modal.Content>
                </Modal>
            </RoleGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    [SPRAY_SUBMISSION_VIEW_PAYLOAD_MODAL]: makeSelectQueryStringBooleanValue(
        SPRAY_SUBMISSION_VIEW_PAYLOAD_MODAL
    ),
    spraySubmissionId: makeSelectQueryStringNumberValue('spraySubmissionId'),
    spraySubmissionPayload: makeSelectSpraySubmissionPayload()
});

export default connect(mapStateToProps, { updateQueryString })(
    SpraySubmissionViewPayloadModalComponent
);
